import styled from "styled-components"

import { when, minWidth } from "utils"

import TextAndImage from "components/text-and-media/text-and-image"
import CloudinaryImage from "components/cloudinary-image"

export const Container = styled(TextAndImage)`
  background-color: ${({ theme }) => theme.colors.background.primary || "#fff"};
  max-width: calc(100% - 5.4rem);
  margin: 0 auto;

  ${when("border")`
    border: 0.1rem solid #22222233";
  `}

  ${minWidth.tablet`
    max-width: 57rem;

    ${when("below")`
      max-width: 58rem;
    `}
  `}

  ${minWidth.desktop`
    max-width: 72rem;

    ${when("below")`
      margin-left: 5rem;
    `}
  `}

  ${minWidth.hamburgerLarge`
    max-width: 76rem
    margin: 0 2rem;
  `}

  ${minWidth.desktopL`
    ${when("below")`
     margin-left: 12rem;
    `}
  `}

  // horizontal
  > div {
    align-items: center;
    max-width: 100%;

    > * {
      max-width: 100%;
      flex: 0 0 100%;

      &:nth-child(2) {
        max-width: 100%;
        flex: 0 0 100%;
        margin: 0;
      }
    }

    ${minWidth.desktop`
      > * {
        max-width: 100%;

        &:nth-child(1) {
          max-width: 40%;
          flex: 0 0 40%;
        }

        &:nth-child(2) {
          max-width: 40%;
          flex: 0 0 40%;
        }
      }
    `}

    ${minWidth.hamburgerLarge`
    > * {
      max-width: 100%;

      &:nth-child(1) {
        max-width: 60%;
        flex: 0 0 60%;
      }

      &:nth-child(2) {
        max-width: 36%;
        flex: 0 0 40%;

      }
    }

    `}
    > div {
      width: 100%;

      // left:
      &:nth-child(1) {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 1rem;

        ${minWidth.tablet`
          padding: 1rem;
        `}

        // preheading
        h3 {
          font-weight: 500;
          font-size: 12px;
          line-height: 1.2;
          color: ${({ theme }) => theme.colors.primaryOrange};
          font-family: "Maax";
          margin: 0 0 2rem 1rem;

          ${minWidth.hamburgerLarge`
            font-size: 1rem;
            line-height: 1.6;
          `}
        }

        // heading
        h1 {
          font-size: 2.4rem;
          font-weight: 400;
          line-height: 1.35;
          margin: 0 0 0 1rem;
          color: ${({ theme }) => theme.colors.text.primary};
        }

        // body text
        div > p {
          margin: 0 0 0 1rem;
          padding-top: 0.5rem;
          font-size: 1.6rem;
          line-height: 1.35;
          color: ${({ theme }) => theme.colors.text.primary};

          ${minWidth.hamburgerLarge`
            font-size: 1.8rem;
            line-height: 1.667;
          `}
        }

        button {
          margin: 2rem 0;
          background-color: ${({ theme }) => theme.colors.primaryOrange};
          width: 99%;
          height: 30px;
          font-size: 1.2rem;

          ${minWidth.desktop`
            width: 130px;
            margin: 0;
          `}
        }
      }
      // right: media
      &:nth-child(2) {
        order: -1;
        margin: 0;
        align-items: center;
        height: 21rem;

        ${minWidth.tablet`
          height: 41rem;
         `}

        ${minWidth.desktop`
          height: auto;
        `}
      }
    }
  }
`

export const ImageContainer = styled.div`
  overflow: hidden;
  margin: 2rem;
  position: relative;
  object-fit: cover;

  ${minWidth.desktop`
    width: 100%;
    height: 100%;
    margin: 0;
  `}
`
export const StyledImage = styled(CloudinaryImage)`
  width: 100%;
  height: 30rem;
  object-fit: fill;

  ${minWidth.desktop`
    width: 100%;
    height: 100%;
    margin: 0;
  `}
`
